<template lang="pug">
  .spaceView(:style="style")
    space-view-item(v-for="(div, index) in preparedDivs", :div="div", :height="height", :key="index")
</template>
<script>
import _ from 'lodash'
import SpaceViewItem from './SpaceViewItem'
export default {
  props: {
    'divs': Array,
    'options': {
      type: Object,
      required: false,
      'default' () {
        return {
          height: 30
        }
      }
    }
  },
  components: {
    SpaceViewItem
  },
  computed: {
    height () {
      return this.options.height || 30
    },
    style () {
      return {
        height: this.height + 'px'
      }
    },
    sum () {
      var d, sum, _i, _len, _ref
      sum = 0
      _ref = this.divs
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        d = _ref[_i]
        sum += d.value
      }
      return sum
    },
    preparedDivs () {
      var sum
      sum = this.sum
      return _.map(this.divs, function (d) {
        return {
          size: d.value * 100 / sum,
          color: d.color || 'white',
          fgcolor: d.fgcolor || '#000',
          text: d.text || d.name,
          originalDiv: d
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// SpaceView.vue?52f43b26